import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white py-6 px-8 rounded-xl w-[480px] max-w-[90vw]" }
const _hoisted_2 = { class: "text-xl font-semibold mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_4 = {
  key: 1,
  class: "max-h-96 overflow-y-auto"
}
const _hoisted_5 = { class: "w-full text-sm border-collapse" }
const _hoisted_6 = { class: "border-b border-gray-200" }
const _hoisted_7 = { class: "py-2 pr-4 text-left font-semibold text-gray-700" }
const _hoisted_8 = { class: "py-2 pr-4 text-left font-semibold text-gray-700" }
const _hoisted_9 = { class: "py-2 text-right font-semibold text-gray-700" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "py-2 pr-3" }
const _hoisted_12 = ["checked", "onChange"]
const _hoisted_13 = { class: "py-2 pr-4 font-medium text-gray-900" }
const _hoisted_14 = { class: "py-2 pr-4 text-gray-500 tabular-nums" }
const _hoisted_15 = {
  key: 0,
  class: "ml-1 text-xs text-gray-400"
}
const _hoisted_16 = { class: "py-2 text-right text-gray-700 tabular-nums" }
const _hoisted_17 = { class: "py-2 pl-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "mt-4 text-xs text-gray-500" }
const _hoisted_20 = {
  key: 1,
  class: "mt-2 bg-gray-50 border border-gray-200 rounded-lg p-3 text-xs text-gray-500 leading-relaxed"
}
const _hoisted_21 = { class: "flex space-x-4 mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseModalButton = _resolveComponent("CloseModalButton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_EditReconciliationModal = _resolveComponent("EditReconciliationModal")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "close-esc-event": "keydown",
    "close-button": false,
    "modal-class": "m-auto border-0",
    "mask-class": "grid",
    onOpening: _ctx.onOpen,
    onClosing: _ctx.onClose
  }, {
    toggle: _withCtx((scope) => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(scope)))
    ]),
    header: _withCtx((scope) => [
      _createVNode(_component_CloseModalButton, {
        onClose: scope.close
      }, null, 8, ["onClose"])
    ]),
    body: _withCtx((scope) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.header')), 1),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Spinner, {
                class: "w-10 h-10",
                active: true
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("th", { class: "w-8 py-2 pr-3" }, null, -1)),
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.tableColumns.location')), 1),
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.tableColumns.period')), 1),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.tableColumns.amount')), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("th", { class: "w-8 py-2" }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reconciliations, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass(['border-b border-gray-100 cursor-pointer', _ctx.isAutoDeselected(item.id) ? 'bg-yellow-50' : 'hover:bg-gray-50']),
                      onClick: ($event: any) => (_ctx.onToggle(item.id))
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "w-4 h-4 accent-primary-800 cursor-pointer",
                          checked: _ctx.localIds.includes(item.id),
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                          onChange: ($event: any) => (_ctx.onToggle(item.id))
                        }, null, 40, _hoisted_12)
                      ]),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(item.location.name), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(item.from_status_date)) + " – " + _toDisplayString(_ctx.formatDate(item.to_status_date)) + " ", 1),
                        (_ctx.isAutoDeselected(item.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.autoDeselectedNote')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.formatAmount(item.amount_kg)) + " kg", 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createVNode(_component_EditReconciliationModal, {
                          reconciliation: item,
                          onClosing: _ctx.onEditModalClose
                        }, {
                          default: _withCtx(({ open }) => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "p-1 rounded hover:bg-gray-100 transition-colors",
                              onClick: _withModifiers(open, ["stop"])
                            }, [
                              _createVNode(_component_Icon, {
                                class: "h-3.5 w-3.5 opacity-50",
                                src: _ctx.IconSource.Edit
                              }, null, 8, ["src"])
                            ], 8, _hoisted_18)
                          ]),
                          _: 2
                        }, 1032, ["reconciliation", "onClosing"])
                      ])
                    ], 10, _hoisted_10))
                  }), 128))
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.farmBarnMutualExclusionNote')), 1),
          (!_ctx.showDetail)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "text-primary-600 font-semibold underline mt-1 cursor-pointer hover:text-primary-800",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetail = true))
              }, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.readMore')), 1))
            : _createCommentVNode("", true),
          (_ctx.showDetail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('views.reports.selectFeedReconciliations.farmBarnMutualExclusionDetail')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_CustomButton, {
            class: "flex-1",
            "color-preset": "secondary",
            onClick: scope.close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.cancelButton')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_CustomButton, {
            class: "flex-1",
            onClick: ($event: any) => (_ctx.onSave(scope.close))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.saveButton')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["onOpening", "onClosing"]))
}